import { getRequest, postRequest } from 'src/services/requests';

const buscarAplicacoesWeb = (
  security?: boolean
): Promise<{
  success: boolean;
  hash: string;
  messages: string[];
  data: {
    Aplicacoes: [
      {
        Portal: string;
        NomeExibicao: string;
        Nome: string;
        Endereco: string;
        Security: boolean;
        PossuiDireito: boolean;
      }
    ];
  };
}> => {
  return new Promise((resolve, reject) => {
    postRequest(
      `/genericos/ge/ambiente/BuscarAplicacoesWeb?somenteEnderecos=false&security=${
        security || false
      }`,
      '',
      resolve,
      reject
    );
  });
};

const verificarConectividade = (
  url: string,
  allowRedirect: boolean
): Promise<{
  success: boolean;
  messages: string[];
  data: { IsAvailable: boolean };
  tipoLogin: string;
}> => {
  return new Promise((resolve, reject) => {
    getRequest(
      `/genericos/ge/ambiente/VerificarConectividade?url=${url}&allowRedirect=${allowRedirect}`,
      resolve,
      reject
    );
  });
};

export { buscarAplicacoesWeb, verificarConectividade };
